import { Launch } from "@material-ui/icons";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import { useSubscription } from "store/auth/auth-store";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetRealmUri } from "services/input-core/appconfigs/get-realm-uri";

const fieldglassMap = {
  worker: "worker_list.do?cf=1",
  sow: "pay_terms_list.do?cf=1",
  supplier: "supplier_list.do",
  consolidated_worker: "master_worker_list.do?cf=1",
  sowProfile: "pay_terms_request.do?id=",
  workerProfile: "worker.do?id=",
};

interface Props {
  type: keyof typeof fieldglassMap;
  zIdentifier?: string;
}

const FieldglassButton: React.FC<Props> = ({ type, zIdentifier }) => {
  const { t } = useTranslation("common");
  const { subscription } = useSubscription();
  const { data, isLoading: realmUriLoading } = useGetRealmUri(
    subscription?.subscriptionId,
  );

  return (
    <ButtonTS
      color="primary"
      target="_blank"
      style={{
        backgroundColor: "transparent",
        border: "1px solid #EB6C17",
        color: "#EB6C17",
        height: "30px",
      }}
      size="sm"
      href={
        zIdentifier
          ? `${data?.realmUri}/${fieldglassMap[type] + zIdentifier}`
          : `${data?.realmUri}/${fieldglassMap[type]}`
      }
      disabled={realmUriLoading || !data?.realmUri}
    >
      <Launch style={{ width: "16px" }} />
      {t("view-on-fieldglass")}
    </ButtonTS>
  );
};

export default FieldglassButton;
